import { WorkflowTemplate } from '@amzn/finspace-service-typescript-client';
import { NETPPM_STEP_IDS } from 'src/constants/netppm-step-ids';
import { CAPABILITY_NAMES, STEP_IDS } from 'src/constants/mfr-constants';
import { logger } from './logger';

// Simple mapping from document section ID to capability name
export const SECTION_TO_CAPABILITY_MAP: Record<string, string> = {
  [STEP_IDS.EXECUTIVE_PNL_EXECUTIVE_SUMMARY]: CAPABILITY_NAMES.EXECUTIVE_PNL_EXECUTIVE_SUMMARY,
  [STEP_IDS.EXECUTIVE_PNL_PNL_BY_CHANNEL]: CAPABILITY_NAMES.EXECUTIVE_PNL_PNL_BY_CHANNEL,
  [STEP_IDS.EXECUTIVE_PNL_PNL_BY_GL]: CAPABILITY_NAMES.EXECUTIVE_PNL_PNL_BY_GL,
  [STEP_IDS.EXECUTIVE_PNL_PNL_BY_MARKETPLACE]: CAPABILITY_NAMES.EXECUTIVE_PNL_PNL_BY_MARKETPLACE,
  [STEP_IDS.BUSINESS_TRENDS_TOP_BOTTOM_BRANDS]: CAPABILITY_NAMES.BUSINESS_TRENDS_TOP_BOTTOM,
  [STEP_IDS.BUSINESS_TRENDS_TOP_BOTTOM_ASINS]: CAPABILITY_NAMES.BUSINESS_TRENDS_TOP_BOTTOM,
  [STEP_IDS.COST_TO_SERVE]: CAPABILITY_NAMES.COST_TO_SERVE,
  [STEP_IDS.DETAILED_PNL]: CAPABILITY_NAMES.DETAILED_PNL,
  [STEP_IDS.PL_SLICE]: CAPABILITY_NAMES.PL_SLICE,
  [STEP_IDS.PL_DRILL_DOWN]: CAPABILITY_NAMES.PL_DRILL_DOWN,
  // Dynamic children from P&L by Slice
  [STEP_IDS.PNL_BY_SLICE_ASP_BAND]: CAPABILITY_NAMES.PL_SLICE,
  [STEP_IDS.PNL_BY_SLICE_EVERYDAY_ESSENTIALS]: CAPABILITY_NAMES.PL_SLICE,
  [STEP_IDS.PNL_BY_SLICE_FC_TYPE]: CAPABILITY_NAMES.PL_SLICE,
  [STEP_IDS.PNL_BY_SLICE_PRIME_PLAN]: CAPABILITY_NAMES.PL_SLICE,
  [STEP_IDS.PNL_BY_SLICE_PRIVATE_BRANDS]: CAPABILITY_NAMES.PL_SLICE,
  [STEP_IDS.PNL_BY_SLICE_SORT_TYPE]: CAPABILITY_NAMES.PL_SLICE,
  [STEP_IDS.PNL_BY_SLICE_IS_SNS]: CAPABILITY_NAMES.PL_SLICE,
  [STEP_IDS.PNL_BY_SLICE_BRAND_NAME]: CAPABILITY_NAMES.PL_SLICE,
  [STEP_IDS.PNL_BY_SLICE_ITEM_SIZE]: CAPABILITY_NAMES.PL_SLICE,
  [STEP_IDS.PNL_BY_SLICE_SIOC]: CAPABILITY_NAMES.PL_SLICE,
  [STEP_IDS.PNL_BY_SLICE_HCTP]: CAPABILITY_NAMES.PL_SLICE,
  [STEP_IDS.PNL_BY_SLICE_TEXTBOOK_TYPE]: CAPABILITY_NAMES.PL_SLICE,
  [STEP_IDS.PNL_BY_SLICE_AMAZON_RENEWED]: CAPABILITY_NAMES.PL_SLICE,
  [STEP_IDS.PNL_BY_SLICE_SPEED_PROGRAM]: CAPABILITY_NAMES.PL_SLICE,
  [STEP_IDS.PNL_BY_SLICE_JP_HEAVYBULKY]: CAPABILITY_NAMES.PL_SLICE,
  [STEP_IDS.PNL_BY_SLICE_IS_B2B]: CAPABILITY_NAMES.PL_SLICE,
  [STEP_IDS.PNL_BY_SLICE_AB_SECTOR]: CAPABILITY_NAMES.PL_SLICE,
  [STEP_IDS.PNL_BY_SLICE_AB_REVENUE_TIER]: CAPABILITY_NAMES.PL_SLICE,
  [STEP_IDS.PNL_BY_SLICE_AB_USER_TYPE]: CAPABILITY_NAMES.PL_SLICE,
  [STEP_IDS.PNL_BY_SLICE_COUPONS]: CAPABILITY_NAMES.PL_SLICE,
  [STEP_IDS.PNL_BY_SLICE_SELLER_FULFILLED_PRIME]: CAPABILITY_NAMES.PL_SLICE,
  [STEP_IDS.PNL_BY_SLICE_SPECIAL_HANDLING_US]: CAPABILITY_NAMES.PL_SLICE,
  // Dynamic children from P&L Drill Down
  [STEP_IDS.PNL_DRILL_DOWN_NET_REVENUE]: CAPABILITY_NAMES.PL_DRILL_DOWN,
  [STEP_IDS.PNL_DRILL_DOWN_MARKETPLACE_REVENUE]: CAPABILITY_NAMES.PL_DRILL_DOWN,
  [STEP_IDS.PNL_DRILL_DOWN_NET_PPM]: CAPABILITY_NAMES.PL_DRILL_DOWN,
  [STEP_IDS.PNL_DRILL_DOWN_VENDOR_PROFIT]: CAPABILITY_NAMES.PL_DRILL_DOWN,
  [STEP_IDS.PNL_DRILL_DOWN_GROSS_PROFIT]: CAPABILITY_NAMES.PL_DRILL_DOWN,
  [STEP_IDS.PNL_DRILL_DOWN_CONTRIBUTION_PROFIT]: CAPABILITY_NAMES.PL_DRILL_DOWN,
  [STEP_IDS.PNL_DRILL_DOWN_CP_LESS_OPS_FIELD_FIXED]: CAPABILITY_NAMES.PL_DRILL_DOWN,
  [STEP_IDS.PNL_DRILL_DOWN_OPERATING_INCOME]: CAPABILITY_NAMES.PL_DRILL_DOWN,
  [STEP_IDS.PNL_DRILL_DOWN_FREIGHT_IN_TOTAL]: CAPABILITY_NAMES.PL_DRILL_DOWN,
  [STEP_IDS.PNL_DRILL_DOWN_GMS]: CAPABILITY_NAMES.PL_DRILL_DOWN,
  [STEP_IDS.PNL_DRILL_DOWN_NET_SELLER_REIMBURSEMENTS]: CAPABILITY_NAMES.PL_DRILL_DOWN,
  [STEP_IDS.PNL_DRILL_DOWN_OPERATING_MARGIN_PCT]: CAPABILITY_NAMES.PL_DRILL_DOWN,
  [STEP_IDS.PNL_DRILL_DOWN_OPS_CS_VARIABLE_TOTAL]: CAPABILITY_NAMES.PL_DRILL_DOWN,
  [STEP_IDS.PNL_DRILL_DOWN_SHIPPING_COGS]: CAPABILITY_NAMES.PL_DRILL_DOWN,
  [STEP_IDS.PNL_DRILL_DOWN_TOTAL_OPS_FIELD_FIXED]: CAPABILITY_NAMES.PL_DRILL_DOWN,
  [STEP_IDS.PNL_DRILL_DOWN_UNITS]: CAPABILITY_NAMES.PL_DRILL_DOWN,
  // NetPPM capabilities
  [NETPPM_STEP_IDS.GENERATE_PRUNED_VARIANCE_TREE]: 'NetPPM - Generate Pruned Variance Tree',
  [NETPPM_STEP_IDS.USER_TREE_SELECTION]: 'Request User Input',
  [NETPPM_STEP_IDS.GENERATE_COMMENTARY]: 'NetPPM - Generate Commentary',
};

// Helper function to get capability ID by name from workflow template
export function getCapabilityId(workflowTemplate: WorkflowTemplate, sectionId: string): string | undefined {
  
  const capabilityName = SECTION_TO_CAPABILITY_MAP[sectionId];

  if (!capabilityName) {
    return undefined;
  }

  const capability = workflowTemplate.capabilities?.find(cap => cap.name === capabilityName);
  if (capability?.id) {
    logger.info(`Found capability ID: ${capability.id} for ${capabilityName}`);
    return capability.id;
  }

  return undefined;
}
